import { RootState } from "../store/store";
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const cloudApi = createApi({
  reducerPath: "cloud",
  baseQuery: fetchBaseQuery({
    baseUrl: import.meta.env.VITE_API_URI,
    prepareHeaders: (headers, { getState }) => {
      const token = (getState() as RootState).auth.token;
      if (token) {
        headers.set("authorization", `Bearer ${token}`);
      }

      // Add API version header - clean versioning without URL segments!
      headers.set("api-version", "2.0");

      return headers;
    },
  }),
  tagTypes: ["ApiKey", "EvueConfig", "Facility", "FacilityShifts", "FacilitySetting", "Organization", "Tag", "Telemetry", "User", "UserSetting"],
  endpoints: () => ({}),
});
